import { useProfanityStore } from '../services/profanity.service';
import { ProfanityModal } from './ProfanityModal';

export function ProfanityModalProvider() {
  const { isModalOpen, closeProfanityModal } = useProfanityStore();

  return (
    <ProfanityModal
      isOpen={isModalOpen}
      onClose={closeProfanityModal}
    />
  );
}

export default ProfanityModalProvider;
